import { useState, useEffect } from 'react';
import { Flex } from '../../component-library';
import { PatientFacialDetection } from '../../components';
import { useTestContext } from '../../context/testContext';
import { useReceiveMessage } from '../../context/messageContext';
import RandomEImg from '../../assets/img/rightE.bmp';

const RandomE = () => {
  const { testData } = useTestContext();
  const [rotationDegree, setRotationDegree] = useState(0);
  const [currentLogmarSize, setCurrentLogmarSize] = useState(0);
  const messageFromOptician = useReceiveMessage();
  const [logmarData, setLogmarData] = useState({});

  const hasContentChanged = (newLogmarSize, newRotationDegree) => {
    return newLogmarSize !== currentLogmarSize || newRotationDegree !== rotationDegree;
  };

  useEffect(() => {
    if (hasContentChanged(logmarData.size, logmarData.rotationDegree)) {
      setCurrentLogmarSize(logmarData.size);
      setRotationDegree(logmarData.rotationDegree);
    }
  }, [logmarData]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'randomE':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          rotationDegree: messageFromOptician.content.rotationDegree,
        });
        break;
      case 'resizeLogmarImage':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          rotationDegree: messageFromOptician.content.rotationDegree,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testData.testMode} />
      <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center' style={{ zIndex: '9' }}>
        <img
          src={RandomEImg}
          alt='random-e'
          style={{ width: currentLogmarSize, height: currentLogmarSize, overflow: 'hidden', rotate: `${rotationDegree}deg` }}
        />
      </Flex>
    </Flex>
  );
};

export default RandomE;
